import morphism, { StrictSchema } from 'morphism'

import store from '../../store'

import ReduxStoreInterface from '../../interfaces/client/ReduxStore'
import ClientPassengerInterface from '../../interfaces/client/Passenger'
import ClientInfantPassengerInterface from '../../interfaces/client/InfantPassenger'
import ServerNewInfantPassengerInterface from '../../interfaces/server/NewInfantPassenger'
import ServerNewSSRInterface from '../../interfaces/server/NewSSR'
import ClientSSRInterface from '../../interfaces/client/SSR'
import PassengerSSRInterface from '../../interfaces/client/PassengerSSR'

import constants from '../../config/constants'

import { dateFromFrontEndToBackEndFormat } from '../../utils/dates'

import infantSchema from './infant'
import SSRSchema from './SSR'

export const dateOfBirth = (passenger: ClientPassengerInterface) =>
  dateFromFrontEndToBackEndFormat(passenger.dateOfBirth)

export const infant = (passenger: ClientPassengerInterface) => {
  if (!passenger.infant) return undefined

  return morphism<
    StrictSchema<
      ServerNewInfantPassengerInterface,
      ClientInfantPassengerInterface
    >
  >(infantSchema, {
    ...passenger.infant,
    id: passenger.infant.id ? passenger.infant.id : passenger.id,
  })
}

const getLuggageSSR = (ssrId: string) => {
  const SSRs = store.getState().ssrs

  return {
    ...SSRs.byId[ssrId],
    // Manually add ssrNumber, otherwise the API doesn't accept the luggage SSR
    ssrNumber: 1,
  }
}

const getSSRs = (passengerId: string) => {
  const state: ReduxStoreInterface = store.getState()
  const passengerSSRs = state.passengerSSRs.byId[passengerId]

  if (!passengerSSRs) return []

  return passengerSSRs
    .filter((passengerSSR: PassengerSSRInterface) => !passengerSSR.toDelete)
    .map((passengerSSR: PassengerSSRInterface) => {
      const ssr = state.ssrs.byId[passengerSSR.ssrId]

      return {
        ...ssr,
        attributes: passengerSSR.dimensions,
        note: passengerSSR.note ? passengerSSR.note : '',
        ssrNumber: passengerSSR.ssrNumber,
      }
    })
}

export const SSRs = (passenger: ClientPassengerInterface) => {
  const passengerSSRs = getSSRs(passenger.id)

  if (passenger.luggage) {
    passengerSSRs.push(getLuggageSSR(passenger.luggage))
  }

  return passengerSSRs.map((SSR: ClientSSRInterface) =>
    morphism<StrictSchema<ServerNewSSRInterface, ClientSSRInterface>>(
      SSRSchema,
      SSR
    )
  )
}

export const travelClass = (passenger: ClientPassengerInterface) =>
  passenger.travelClass ? passenger.travelClass : constants.defaultTravelClass

export default {
  dateOfBirth,
  firstName: 'firstName',
  gender: 'gender',
  id: 'id',
  infant,
  lastName: 'lastName',
  ssrs: SSRs,
  thirdPartyBookingNumber: 'thirdPartyBookingNumber',
  transaviaBookingNumber: 'transaviaBookingNumber',
  travelClass,
}
